function validateQueue(queue) {
  if (!Array.isArray(queue)) {
    throw new TypeError('queue must be an array');
  }
}

function validateCapacity(capacity) {
  if (!Number.isSafeInteger(capacity) || capacity <= 0) {
    throw new RangeError('capacity must be a positive safe integer');
  }
}

export function enqueueEvent(queue, event, capacity = 20) {
  validateQueue(queue);
  validateCapacity(capacity);
  const next = [...queue, event];
  const dropped = next.slice(0, Math.max(0, next.length - capacity));
  const retained = next.slice(dropped.length);
  return { queue: retained, dropped };
}

export function drainEvents(queue, consent, ready) {
  validateQueue(queue);
  if (consent !== true) {
    return { queue: [], events: [], dropped: [...queue] };
  }
  if (ready !== true) {
    return { queue: [...queue], events: [], dropped: [] };
  }
  return { queue: [], events: [...queue], dropped: [] };
}
